import { withInstall } from '@bigin/utils'

import Space from './src/space'

export const BSpace = withInstall(Space)
export default BSpace

export * from './src/space'
export * from './src/item'
export * from './src/use-space'
